import { t } from 'i18next';
import { CHINA_NATIONALITY_VALUE } from 'src/constants';
import { CHINESE_MOBILE_LENGTH, CHINESE_REGEX, PASSPORT_REGEX } from 'src/constants/validation';
import { i18nKey } from 'src/locales/i18n';

export function checkChineseCharacters(_: any, value: string) {
	if (!value) return Promise.resolve();
	if (value.match(CHINESE_REGEX) || value === '') {
		const validateInput = value.split(' ').join('');
		const chineseWordValidate = value.match(CHINESE_REGEX);
		if (validateInput.length === chineseWordValidate?.length) {
			return Promise.resolve();
		}
	}
	return Promise.reject(new Error(`${t(i18nKey.onboarding.validation.inputOnlyChineseCharacters)}`));
}

export function isValidPassport(passportStr: string): boolean {
	return PASSPORT_REGEX.test(passportStr);
}

export async function checkLengthCharacters(value: string, length: number[], isChinese: string | boolean) {
	if (!value) {
		return Promise.resolve();
	}
	if ((isChinese === true || isChinese === CHINA_NATIONALITY_VALUE) && !length.includes(value.length)) {
		return Promise.reject(
			new Error(
				`${
					length === CHINESE_MOBILE_LENGTH
						? 'Please enter a value with length of 11 characters'
						: 'Please enter a value with length of 15 or 18 characters'
				}`
			)
		);
	}
	return Promise.resolve();
}